// File: noviopus-ats-client/src/App/reducers.ts
import { combineReducers } from 'redux';
import { fromJS } from 'immutable'; 
import { ensureImmutable } from '@/utils/safeImmutable';

// Modern Slices
import authReducer, { LOGOUT } from '@/features/Auth/authSlice'; 
import { reducer as onBoardingFlowReducer } from '@/features/OnBoardingFlow';
import directionReducer from '@/features/direction/directionSlice';
import languageReducer from '@/features/language/languageSlice';
import languagesListReducer from '@/features/languagesList/languagesListSlice';
import navigationReducer from '@/features/Navigation/contextSlice';
import pageLayoutReducer from '@/features/PageLayout/pageLayoutSlice';
import hiringReducer from '@/features/Hiring/slice';

// NEW: Job V3 Slice (Fixes the Redirect Loop)
import { reducer as jobCreateReducer } from '@/features/Job';

import dashboardReducer from '@/features/Dashboard/dashboardSlice';
import organizationReducer from '@/features/Organization/organizationSlice';
import recruitmentDashboardReducer from '@/features/RecruitmentDashboard/slice';
import teamReducer from '@/features/Team/teamSlice';
import campaignsReducer from '@/features/Campaigns/campaignsSlice';

// Legacy Reducers
import globalReducer from '@/Main/reducer';
import toastrReducer from '@/components/Toastr/reducer';
import promptReducer from '@/components/PromptDialog/reducer';
import { reducer as reduxFormReducer } from 'redux-form'; 
import dbAutocompleteReducer from '@/components/DBAutocomplete/reducer';
import customFormReducer from '@/components/Form/reducer';
import datasourceReducer from '@/Datasource/reducer';
import settingsReducer from '@/Pages/Account/reducer';
import modelsReducer from '@/models/reducer';
import locationSelectReducer from '@/components/LocationSelect/reducer';
import accountLocationSelectReducer from '@/components/AccountLocationSection/reducer';
import socketReducer from '@/socket/reducer';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

const routeInitialState = fromJS({
  locationBeforeTransitions: null,
});

function routeReducer(state = routeInitialState, action: any) {
  switch (action.type) {
    case LOCATION_CHANGE:
      return state.merge({
        locationBeforeTransitions: action.payload,
      });
    default:
      return state;
  }
}

export default function createReducer(asyncReducers: any = {}) {
  const appReducer = combineReducers({
    route: routeReducer, 
    auth: authReducer,
    
    // Modern Features
    onBoardingFlow: onBoardingFlowReducer,
    direction: directionReducer,
    language: languageReducer,
    languagesList: languagesListReducer,
    navigation: navigationReducer,
    pageLayout: pageLayoutReducer,
    dashboard: dashboardReducer,
    organization: organizationReducer,
    recruitmentDashboard: recruitmentDashboardReducer,
    jobCreate: jobCreateReducer,
    hiring: hiringReducer,
    team: teamReducer,
    campaigns: campaignsReducer,

    // Legacy Features
    global: globalReducer,
    toastr: toastrReducer,
    prompt: promptReducer,
    form: reduxFormReducer,
    dbAutocomplete: dbAutocompleteReducer,
    customForm: customFormReducer,
    datasource: datasourceReducer,
    settings: settingsReducer,
    models: modelsReducer,
    locationSelect: locationSelectReducer,
    accountLocationSelect: accountLocationSelectReducer,
    socket: socketReducer,
    
    ...asyncReducers,
  }) as any;

  const rootReducer = (state: any, action: any) => {
    let nextState = state;
    if (action.type === LOGOUT) {
      const route = state?.route;
      nextState = { route }; 
    }
    return appReducer(nextState, action);
  };

  return rootReducer;
}